module.exports = __webpack_public_path__ + "img/img.5081e805.png";